/**
 * Crisp Chat Widget Initialization
 *
 * Loads the Crisp chat widget using the website ID from environment variables.
 * The widget is hidden by default and can be opened programmatically.
 */

export function initCrisp() {
  const websiteId = process.env.REACT_APP_CRISP_WEBSITE_ID;

  if (!websiteId) {
    console.warn('Crisp: REACT_APP_CRISP_WEBSITE_ID not set, chat widget disabled');
    return;
  }

  // Initialize Crisp globals
  window.$crisp = [];
  window.CRISP_WEBSITE_ID = websiteId;

  // Load Crisp script
  const script = document.createElement('script');
  script.src = 'https://client.crisp.chat/l.js';
  script.async = true;
  document.head.appendChild(script);

  // Hide the default chat button - we'll trigger it from Knewton help button
  script.onload = () => {
    if (window.$crisp) {
      window.$crisp.push(['do', 'chat:hide']);
    }
  };
}

export function openCrispChat() {
  if (window.$crisp) {
    window.$crisp.push(['do', 'chat:show']);
    window.$crisp.push(['do', 'chat:open']);
  }
}

export function closeCrispChat() {
  if (window.$crisp) {
    window.$crisp.push(['do', 'chat:close']);
    window.$crisp.push(['do', 'chat:hide']);
  }
}
